import React from 'react';
import classNames from 'classnames';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { isMobile, isTablet } from 'react-device-detect';

export const ScrollButton = ({
  direction,
  onClick,
  show,
}: {
  direction: 'left' | 'right';
  onClick: () => void;
  show?: boolean;
}) => {
  const isLeft = direction === 'left';
  const Icon = isLeft ? ChevronLeftIcon : ChevronRightIcon;

  if (!show) {
    return null;
  }

  return (
    <div
      onClick={onClick}
      className={classNames('absolute z-[2] rounded-full bg-white/80 backdrop-blur-lg shadow-lg', {
        hidden: isMobile || isTablet,
        'left-2': isLeft,
        'right-2': !isLeft,
      })}
    >
      <Icon
        className="w-[40px] h-[40px] rounded-lg cursor-pointer"
        width={20}
        height={20}
        color="black/60"
      />
    </div>
  );
};

export const DesktopCTAButton = ({ onClick, text }: { onClick: () => void; text: string }) => {
  return (
    <div className="hidden md:block">
      <button
        type="button"
        onClick={onClick}
        className={classNames(
          'pl-8 pr-2 flex items-center justify-center text-black text-md',
          'border-2 border-l-transparent border-r-transparent border-t-transparent border-b-blue-blue active:text-blue-blue',
        )}
      >
        {text}
      </button>
    </div>
  );
};

export const MobileCTAButton = ({ onClick, text }: { onClick: () => void; text: string }) => {
  return (
    <div className="md:hidden">
      <button
        type="button"
        onClick={onClick}
        className={classNames(
          'px-2 bg-blue-blue text-white flex items-center rounded-b-lg justify-center text-md',
          'active:bg-blue-blue/60',
        )}
      >
        {text}
      </button>
    </div>
  );
};
